export const changeDataFun = (date: string) => {
  const months = {
    Jan: '1',
    Feb: '2',
    Mar: '3',
    Apr: '4',
    May: '5',
    Jun: '6',
    Jul: '7',
    Aug: '8',
    Sep: '9',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  // 分割日期字串
  const [day, month, year] = date.split('-');

  // 转换月份，确保 month 的值在 months 对象中是有效的
  const monthNumber = months[month as keyof typeof months];

  const dayWithoutZero = parseInt(day, 10);

  // 返回格式化后的日期
  return `${year}年${monthNumber}月${dayWithoutZero}日`;
};
